require('./show');

var key = getQueryString('key');
var type = getQueryString('type');
if (key) $('.search-word input[type=text]').val(key);
if (type) {
    $('.search-class-item.selected').removeClass('selected');
    $('.search-class-item[type="' + type + '"]').addClass('selected');
}

$(function () {
    $('.search-button').on('click', function () {
        var key = $('.search-word input[type=text]').val();
        var type = $('.search-class-item.selected').attr('type');

        location.href = ROOT + '/search?key=' + key + '&type=' + type;
        // onSearch();
    });

    $('.search-class-item').on('click', function () {
        if ($(this).hasClass('selected')) return;
        $('.search-class-item').removeClass('selected');
        $(this).addClass('selected');
        $('.search-list .list').html('');
        $('.search-list').attr('page', 1);
        onSearch();
    });

    $('.search-list .more').on('click', function () {
        onSearch();
    });

    if ($('.search-class-item.selected').length == 0) {
        $('.search-class-item:first').addClass('selected');
    }

    onSearch();

    getRecommends();
});

function onSearch() {
    var dataType = $('.search-class-item.selected').attr('type');
    var source = '';
    var type = '';
    if (dataType == 'art') {
        source = 'cms';
        type = 'content';
    } else if (dataType == 'live') {
        source = 'live';
        type = 'show';
    } else if (dataType == 'bbs') {
        source = 'community';
        type = 'thread';
    } else if (dataType == 'user') {
        source = 'general';
        type = 'user';
    } else return;

    var data = {
        page: $('.search-list').attr('page'),
        size: 10,
        keyword: $('.search-word input[type=text]').val(),
        source: source,
        type: type
    };
    if (!data.keyword) return;

    $.ajax({
        type: 'post',
        async: false,
        url: '/config/search',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            $('.search-count span').text(data.total);

            if (dataType == 'art') {
                toArtItems(data.data);
            } else if (dataType == 'live') {
                toLiveItems(data.data);
            } else if (dataType == 'bbs') {
                toBbsItems(data.data);
            } else if (dataType == 'user') {
                toUserItems(data.data);
            }
            if (data.data.length < 10) {
                $('.search-list .more').addClass('no-more');
            } else {
                $('.search-list .more').css('display', 'block');
                $('.search-list').attr('page', parseInt($('.search-list').attr('page')) + 1);
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function toArtItems(data) {
    var newlist = '';
    for (var i = 0; i < data.length; i++) {
        var info = data[i];
        if (info.thumbnail_urls === undefined || info.thumbnail_urls == null || info.thumbnail_urls == '')
            info.thumbnail_urls = [];

        var bottominfo = '';
        bottominfo += '<div class="news_info">';
        // bottominfo += '<div class="user">' + info.author_nickname + '</div>';
        // if (info.author_avatar_url) {
        //     bottominfo += '<div class="user">';
        //     bottominfo += '<img src="' + info.author_avatar_url + '?w=18&h=18&s=3' + '"/>' + info.author_nickname;
        //     bottominfo += '</div>';
        // } else
        //     bottominfo += '<div class="user"><img src="/static/images/no-avatar.png"/>' + info.author_nickname + '</div>';
        
        bottominfo += '<div class="time">' + info.source + '</div>'
        bottominfo += '<div class="time">' + info.publish_time + '</div>';
        bottominfo += '<div class="reply">';
        if (info.comment_count > 0)
            bottominfo += '<div class="reply_count">' + info.comment_count + '评论</div>';
        if (info.view_count > 0)
            bottominfo += '<div class="reply_count">' + info.view_count + '浏览</div>';
        bottominfo += '</div>';
        bottominfo += '</div>';

        newlist += '<div class="newsItem">';
        // 只显示有图和无图两种情况
        if (info.list_item_mode == 0 || info.thumbnail_urls.length == 0 || !info.thumbnail_urls[0]) { // 无图
            newlist += '<div class="news_body">';
            newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
            newlist += '<div class="news_content">';
            if (info.body)
                newlist += info.body;
            newlist += '</div>';
            newlist += '</div>';
            newlist += bottominfo;
        } else {
            newlist += '<div class="newsPicture">';
            newlist += '<a href="' + info.url + '" target="_blank">';
            newlist += '<img src="' + info.thumbnail_urls[0] + '?w=200&h=150&s=3' + '"/>';
            newlist += '</a>';
            newlist += '</div>';
            newlist += '<div class="newsInfo">';

            newlist += '<div class="news_body">';
            newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
            newlist += '<div class="news_content">';
            if (info.body)
                newlist += info.body;
            newlist += '</div>';
            newlist += '</div>';
            newlist += bottominfo;
            newlist += '</div>';
        }
        newlist += '</div>';
        newlist += '<div class="dividing-line"></div>';
    }
    if ($('.search-list').attr('page') == '1') {
        $('.search-list .list').html(newlist);
    } else {
        $('.search-list .list').append(newlist);
    }
}

function toLiveItems(data) {
    var newlist = '';
    for (var i = 0; i < data.length; i++) {
        var info = data[i];

        newlist += '<div class="liveitem" data-id="' + info.id + '">\
                        <a href="' + info.url + '" target="_blank" class="liveitem-img">\
                            <img src="' + info.cover_url + '">\
                            <div class="liveitem-state">' + info.state + '</div>\
                        </a>\
                        <a href="' + info.url + '" target="_blank" class="liveitem-title">\
                            ' + info.title + '\
                        </a>\
                        <div class="liveitem-info">\
                            <div class="liveitem-username">' + info.owner_nickname + '</div>\
                            <div class="liveitem-visitor">' + info.current_visitor_count + '人参与</div>\
                        </div>\
                    </div>';
    }
    if ($('.search-list').attr('page') == '1') {
        $('.search-list .list').html(newlist);
    } else {
        $('.search-list .list').append(newlist);
    }
}

function toBbsItems(data) {
    var newlist = '';
    var attachments = '';
    var btnhtml = '';
    for (var i = 0; i < data.length; i++) {
        var info = data[i];
        var pichtml = '';
        if (info.attachments) {
            for (var j = 0; j < info.attachments.length; j++) {
                pichtml += '<img src="' + info.attachments[j] + '" />';
                attachments += info.attachments[j] + ',';
            }
        }

        newlist += '<div class="community-Item">\
                        <div class="item-top">\
                            <div class="item-avatar">\
                            <img src="' + info.author_avatar_url + '?w=52&h=52&s=3">\
                            </div>\
                            <div class="item-user">\
                                <div class="item-nickname">' + info.author_nickname + '</div>\
                                <div class="item-time">' + info.post_time + '</div>\
                            </div>\
                        </div>\
                        <div class="item-middle">\
                            <div class="item-picture">' + pichtml + '</div>\
                            <div class="item-content" href="' + info.url + '">' + info.content + '</div>\
                        </div>\
                        <div class="item-bottom">\
                            <div class="item-count"><div class="favorite">收藏</div></div>\
                            <div class="item-count"><div class="reply">' + info.reply_count + '</div></div>\
                            <div class="item-count"><div class="share">0</div></div>\
                            <div class="item-count"><div class="like">点赞</div></div>\
                        </div>\
                    </div>';
    }
    if ($('.search-list').attr('page') == '1') {
        $('.search-list .list').html(newlist);
    } else {
        $('.search-list .list').append(newlist);
    }
}

function toUserItems(data) {
    var newlist = '';

    for (var i = 0; i < data.length; i++) {
        var info = data[i];
        newlist += '<div class="followItem">';
        if (info.avatar_url == null || info.avatar_url == '')
            info.avatar_url = '/static/images/no-avatar.png';
        else
            info.avatar_url += '?w=60&h=60&s=3';
        newlist += '<div class="follow-avatar"><img src="' + info.avatar_url + '" /></div>';
        newlist += '<div class="follow-user">';
        newlist += '<div class="follow-name">' + info.nickname + '</div>';
        if (info.signature == null || info.signature == '')
            info.signature = '';
        newlist += '<div class="follow-signature">' + info.signature + '</div>';
        newlist += '<div class="follow-btn" dataid="' + info.id + '">添加关注</div>';
        newlist += '</div>';
        newlist += '</div>';
    }
    if ($('.search-list').attr('page') == '1') {
        $('.search-list .list').html(newlist);
    } else {
        $('.search-list .list').append(newlist);
    }
}

function getRecommends() {
    $.ajax({
        type: 'get',
        async: false,
        url: '/home/recommends',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data == '')
                return;
            if (data.message !== undefined) {
                return;
            }
            if (data.data === undefined) {
                return;
            }
            var newlist = '';
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                newlist += '<div class="recommends-item">';
                newlist += '<div class="recommends-item-title"><a href="' + info.url + '" target="_blank">' + info.title + '</a></div>';
                newlist += '<div class="recommends-item-time">' + info.publish_time + '</div>';
                newlist += '</div>';
            }

            $('.recommends .recommends-items').html(newlist);
        },
        error: function (data) {
            console.log(data);
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./home/client/js/search.page.js
// module id = 30
// module chunks = 1